import React, { useState, useEffect, useMemo } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { FormProvider, useForm, Controller } from "react-hook-form";
import _ from "lodash";
import DataGrid from "./DataGrid";
import { AddEditeModal } from "./AddEditeModal";
import { useLocation } from "react-router-dom";
import ApiSms from "../../../core/api/api.sms";
import { InputGroup, Button, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import ApiOrdersService from "../../../core/api/api.ordersService";
import { useNavigate } from "react-router-dom";
import { tools } from "../../../core/utils/tools";
import SelectComponent from "../_Components/ReactSelectComponent";
import GlobalFormControl from "../_Components/GlobalFormControl";

export const SmsInfo = () => {
  const [listData, setListData] = useState([{}]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [show, setShow] = useState(false);
  const [dataForShow, setDataForShow] = useState({});
  const [smsTypes, setSmsTypes] = useState([{}]);
  const status = useMemo(() => [
    { id: 1, value: true, label: "ارسال شده" },
    { id: 2, value: false, label: "ارسال نشده" },
  ], []);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [dateTimeSendOf, setdateTimeSendOf] = useState();
  const [dateTimeSendTo, setdateTimeSendTo] = useState();
  const [showModalSmsInfo, setShowModalSmsInfo] = useState(false);
  const [selectedSms, setSelectedSms] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const types = await ApiOrdersService.GetEnumsName("SmsType");
        setSmsTypes(types.data);
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
        const data = await ApiSms.getAllSms({
          receivePhoneNumber: searchParams.get("receivePhoneNumber"),
          isSend: searchParams.get("isSend") ? searchParams.get("isSend") == "true" : "",
          globalSearch: searchParams.get("globalSearch"),
          dateTimeSendOf: searchParams.get("dateTimeSendOf"),
          dateTimeSendTo: searchParams.get("dateTimeSendTo"),
          smsType: _.toString(searchParams.get("smsType")),
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        setValue("isSend", status.find(st => st.value == (searchParams.get("isSend") && searchParams.get("isSend") == "true")));
        const formInputs = [
          { name: "receivePhoneNumber", type: "text" },
          { name: "dateTimeSendOf", type: "datePicker" },
          { name: "dateTimeSendTo", type: "datePicker" },
          { name: "smsType", type: "multiSelect", isMulti: true, data: types.data },
          { name: "globalSearch", type: "text" },
          { name: "totalCount", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    if (data.dateTimeSendOf && typeof data.dateTimeSendOf === "object") {
      data.dateTimeSendOf = tools.DateFormat(data.dateTimeSendOf);
    }
    if (data.dateTimeSendTo && typeof data.dateTimeSendTo === "object") {
      data.dateTimeSendTo = tools.DateFormat(data.dateTimeSendTo);
    }
    if (data.smsType?.length > 0) data.smsType = data.smsType?.map((item) => item.value);
    if (data.isSend) data.isSend = `${data.isSend.value}`
    data.smsType = _.toString(data.smsType);
    const apiData = await ApiSms.getAllSms(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    tools.setPageNumber(data, searchParams, setValue);
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/smsInfo?${queryString}`);
  };
  function handleChangeMultiSmsType(value) {
    setValue("smsType", value);
  }
  const callBack = (index) => {
    setShow(true);
    setDataForShow(index);
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت پیامک ها</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست اطلاعات ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            {/* <Link
              className="btn btn-primary"
              // variant="success"
              key={0}
              to={{
                pathname: "/smsInfo/0",
                state: { id: "0" },
              }}
            >
              <AddCircle className="mr-1" />
              ارسال پیام
            </Link> */}
          </div>
        </div>

        {/*Start body */}

        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" key={1} onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3" className="tb-reponsive mb-5 px-2">
                            <Controller
                              name="dateTimeSendOf"
                              control={control}
                              variant="outline"
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  placeholder="زمان ارسال از"
                                  onChange={(date) => {
                                    var dateTimeSendTo = getValues("dateTimeSendTo");
                                    onChange(date);
                                    if (
                                      !dateTimeSendTo ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(dateTimeSendTo).getTime())
                                    ) {
                                      // Set the value of dateTimeSendTo to the same as dateTimeSendTo
                                      setValue("dateTimeSendTo", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive mb-5 px-2">
                            <Controller
                              name="dateTimeSendTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker value={value} onChange={onChange} placeholder="زمان ارسال تا" />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive mb-5  px-2">
                            <Controller
                              name="isSend"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={status}
                                  placeholder="وضعیت"
                                  field={field}
                                  className="mt-0"
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive mb-5 px-2">
                            <Controller
                              name="smsType"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-0"
                                  placeholder="نوع "
                                  options={smsTypes?.map((item) => ({
                                    value: item.id,
                                    label: item.id + "-" + item.title,
                                  }))}
                                  field={field}
                                  onChange={handleChangeMultiSmsType}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs="12" className="tb-reponsive px-2">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="ml-3"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                            >
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        sx={{ flexGrow: 1 }}
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={listData}
                  callBack={callBack}
                  setShowModalSmsInfo={setShowModalSmsInfo}
                  setSelectedSms={setSelectedSms}
                />
              </Col>
              {showModalSmsInfo && (
                <AddEditeModal
                  showModalSmsInfo={showModalSmsInfo}
                  setShowModalSmsInfo={setShowModalSmsInfo}
                  selectedSms={selectedSms}
                />
              )}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};
